import React, { createContext, useContext, useState, ReactNode } from "react";
import { User } from "../../types/User";

interface UserContextProps {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

export const emptyUser: User = {
  id: "",
  username: "",
  email: "",
  avatarUrl: "",
  leagues: [],
  favoriteTeams: [],
  lastFiveBets: [],
  score: { id: 0, perfectBets: 0, correctBets: 0, wrongBets: 0, points: 0 },
};

export const UserProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User>(emptyUser);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <UserContext.Provider value={{ user, setUser, isLoading, setIsLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = (): UserContextProps => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
